<template>
  <section>
    <div class="modal-body">
      <form v-on:keyup.esc="reset()" @submit.prevent="submitForm" class="m-form m-form--state" >
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <div class="col-lg-4" :class="{'has-danger': errors.has('identification_number')}">
              <label>{{ 'identification_number' | capitalize }}</label>
              <input type="text" id="id_number" v-model="id_number" name="identification_number" class="form-control m-input" ref="id_num" v-validate="'required|numeric|min:4|max:20'">
              <span v-show="errors.has('identification_number')" class="m-form__help m--font-danger"> {{errors.first('identification_number')}} </span>
            </div>
            <div class="col-lg-4" :class="{'has-danger': errors.has('lastname')}">
              <label>{{ 'lastname' | capitalize }}</label>
              <input type="text" id="lastname" v-model="lastname" name="lastname" class="form-control m-input" v-validate="'required|alpha_spaces|min:3|max:100'">
              <span v-show="errors.has('lastname')" class="m-form__help m--font-danger"> {{errors.first('lastname')}} </span>
            </div>
            <div class="col-lg-4" :class="{'has-danger': errors.has('name')}">
              <label>{{ 'name' | capitalize }}</label>
              <input type="text" id="p_name" v-model="p_name" name="name" class="form-control m-input" v-validate="'required|alpha_spaces|min:3|max:100'">
              <span v-show="errors.has('name')" class="m-form__help m--font-danger"> {{errors.first('name')}} </span>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <div class="col-lg-4" :class="{'has-danger': errors.has('credential_type')}">
              <label>{{ 'credential_type' |translate | capitalize }}</label>
              <select v-on:keyup.tab="disable()" name="credential_type" id="credential_type" :class="{'form-control': true, 'error': errors.has('credential_type') }" v-model="credential_type">
                <option value="" selected disabled hidden>{{ 'select_an_option' | capitalize }}</option>
                <option v-if="credential_type.add_in_reception === 1" v-for="(credential_type, key) in credential_list" :key="key" :value="credential_type.id">{{ credential_type.name | translate | capitalize }}</option>
              </select>
              <span v-show="errors.has('credential_type')" class="m-form__help m--font-danger"> {{errors.first('credential_type')}} </span>
            </div>
            <div class="col-lg-4" :class="{'has-danger': errors.has('credential_value')}">
              <label>{{ 'credential_value' | translate | capitalize }}</label>
              <input v-on:click="enable()" type="text" id="credential_value" v-model="credential_value" name="credential_value" class="form-control m-input" v-validate="'numeric|min:4|max:20'">
              <span v-show="errors.has('credential_value')" class="m-form__help m--font-danger"> {{errors.first('credential_value')}} </span>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-4 pb-4"></div>
              <div class="col-lg-11 text-right">
                <button v-on:click="add_companion()" type="button" class="btn btn-success m-btn m-btn--icon m-btn--wide" data-toggle="modal" data-backdrop="static" data-keyboard="false">
                  <span>
                    <i class="la la-plus"></i>
                    <span>{{ 'add'| translate | capitalize }}</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button v-on:click="reset()" type="button" class="btn btn-secondary" data-dismiss="modal" id="btn-cancel">
        {{'close' | translate | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: { data: Object },
  data () {
    return {
      credential_type: '',
      credential_list: {},
      id_number: '',
      lastname: '',
      p_name: '',
      credential_value: ''
    }
  },
  computed: {
    ...mapGetters({modal: 'getModalStatusReception'})
  },
  methods: {
    ...mapActions(['changeModalStatusReception', 'setModalStatusReception', 'retrieveDetailsReception']),
    disable: function () {
      document.onkeydown = function (e) {
        return false
      }
    },
    enable: function () {
      document.onkeydown = function (e) {
        return true
      }
    },
    focus_id: function () {
      this.$refs.id_num.focus()
    },
    reset: function () {
      this.changeModalStatusReception(false)
      this.enable()
      this.focus_id()
      this.$data.id_number = ''
      this.$data.lastname = ''
      this.$data.p_name = ''
      this.$data.credential_value = ''
      this.credential_type = ''
      this.$validator.reset()
      this.errors.clear()
    },
    add_companion: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$root.$emit('add_c_function', this.$data.id_number, this.$data.lastname, this.$data.p_name, this.$data.credential_value, this.credential_type)
          // this.$toast('companion_added')
          this.reset()
        }
      })
    }
  },
  created () {
    this.retrieveDetailsReception()
      .then((res) => {
        if (res.status === 200) {
          if (res.data.credentials.length === 0) {
            this.credential_list = [{id: '', name: ''}]
          } else {
            this.credential_list = res.data.credentials
          }
        }
      })
      .catch((err) => {
        this.$toast('error_get_data', 4)
        console.log(err)
      })
  },
  watch: {
  }
}
</script>


// WEBPACK FOOTER //
// Companion.vue